import { useQuery } from '@tanstack/react-query';
import { DebatesService, Debate } from '@/services/social/debatesService';

export interface DebateWithMeta extends Debate {
  interview?: {
    id: string;
    title: string;
    interviewee_name: string;
  };
  argument_count: number;
}

export const useAllDebates = (limit = 20) => {
  const {
    data: debates = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['all-debates', limit],
    queryFn: () => DebatesService.getAllActiveDebates(limit),
  });

  return {
    debates: debates as DebateWithMeta[],
    isLoading,
    error,
    refetch,
  };
};
